import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/provider/common.service';

@Component({
  selector: 'app-user-followers',
  templateUrl: './user-followers.component.html',
  styleUrls: ['./user-followers.component.css']
})
export class UserFollowersComponent implements OnInit {
  @Input() UserPostList = ''; 
  searchForm: FormGroup;
  itemsPerPage = 10;
  currentPage = 1;
  totalItems: any;
  customerData: any = [];
  items = [];
  today=new Date().toISOString().split('T')[0]
  flip: boolean = false;
  isSearched: boolean = false;
  statusString: any;
  userId: any;
  status: any;

  constructor(
    private router: Router,
    public commonService: CommonService,
    // private datepipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.searchFormValidation();
    this.getAllfollowerList();
  }

  // search form validation
  searchFormValidation() {
    this.searchForm = new FormGroup({
      search: new FormControl(""),
      fromDate: new FormControl(""),
      toDate: new FormControl(""),
    });
  }

  search() {
    if(this.searchForm.value.search || this.searchForm.value.fromDate || this.searchForm.value.toDate) {
      this.getAllfollowerList();
    }
  }

  reset() {
    if (this.searchForm.value.search || this.searchForm.value.fromDate || this.searchForm.value.toDate) {
      this.searchForm.reset();
      this.getAllfollowerList();
    }
  }

  // get all user list
  getAllfollowerList() {
    let apiReqBody = {
      fromDate:this.searchForm.value.fromDate,
      toDate:this.searchForm.value.toDate,     
      page:this.currentPage,
      limit:this.itemsPerPage
    };
    console.log(apiReqBody);
    let url = `admin/listFollowers?_id=${this.UserPostList}`;
    this.commonService.showSpinner();
    this.commonService.postApi(url, apiReqBody, 1).subscribe((res:any) => {
        if (res.responseCode == 200) {
          this.customerData = res.result.docs;
          this.totalItems = res.result.total;
          this.commonService.hideSpinner();
          this.commonService.successToast(res.responseMessage);
        } else {
          this.commonService.hideSpinner();
          this.commonService.errorToast(res.responseMessage);
        }
      },(err:any)=>{
        if(err.responseCode==404){
          this.totalItems=0
          this.customerData=[]
        }
        else{
          this.customerData=[]
        }
      });
  }

  pagination(event) {
    this.currentPage = event;
    this.getAllfollowerList();
  }



  getUserId(id) {
    // this.userId = id;
    this.router.navigate(["/user-follower-view"], {
      queryParams: {
        id: id,
      },
    });
  }

  
  exportAsXLSX() {
    // let dataArr = [];
    // this.customerData.forEach((element, ind) => {
    //   let obj = {};
    //   obj = {
    //     "S no": ind + 1,
    //     Name: element.firstName
    //       ? element.firstName + " " + element?.lastName
    //       : "N/A",
    //     Email: element.email ? element.email : "N/A",
    //     "Phone No": element.phoneNo ? element.phoneNo : "N/A",
    //     "Created At": element.createTime
    //       ? this.datepipe.transform(element.createTime, "dd/MM/yyyy, hh:mm a")
    //       : "N/A",
    //     Status: element.status ? element.status : "N/A",
    //   };
    //   dataArr.push(obj);
    // });
    // this.commonService.exportAsExcelFile(dataArr, "User Management");
  }
}
